<ion-content class="bg-color ion-content  details-category">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none; cursor: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>

        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <mat-card>
          <mat-card-title class="mc-title">
            <h4 class="mat-title-header">Instances</h4>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <form [formGroup]="addInstanceForm">
                <div class="form-layout">
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Instance</mat-label>
                    <input type="text" formControlName="instance" matInput placeholder="Instance" required>
                  </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Ip Address</mat-label>
                    <input type="text" formControlName="ip_address" matInput placeholder="Ip Address" required>
                  </mat-form-field>
                  </div>
                </div>
                <div class="form-layout">
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Username</mat-label>
                    <input type="text" formControlName="username" matInput placeholder="Username" required>
                  </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>passphrase</mat-label>
                    <input type="password" formControlName="passphrase" matInput placeholder="passphrase" required>
                  </mat-form-field>
                  </div>
                </div>
                <div class="form-layout">
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Hostname</mat-label>
                    <input type="text" formControlName="hostname" matInput placeholder="Hostname" required>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>SSH Port</mat-label>
                    <input type="text" formControlName="ssh_port" matInput placeholder="SSH Port" required>
                  </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Is Default</mat-label>
                    <input type="text" formControlName="is_default" matInput placeholder="Is Default" required>
                    <!-- <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                      formControlName="is_default"
                      [value]="is_default">
                      <mat-button-toggle value="0">No</mat-button-toggle>
                      <mat-button-toggle value="1">Yes</mat-button-toggle>
                    </mat-button-toggle-group> -->
                  </mat-form-field>
                  </div>
                </div>
                <div class="form-layout">
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Port Range From</mat-label>
                    <input type="text" formControlName="port_range_from" matInput placeholder="Port Range From" required>
                  </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Port Range To</mat-label>
                    <input type="text" formControlName="port_range_to" matInput placeholder="Port Range To" required>
                  </mat-form-field>
                  </div>
                </div>
                <div class="form-layout">
                  <div class="form-layout-view" style="display: inline;color: #a3a3a3;">
                  <!-- <mat-form-field appearance="outline"> -->
                    <p style="float: left;margin-right: 15px;">Connection Key: </p>
                    <!-- <input type="text" formControlName="connection_key" matInput placeholder="Connection Key" required> -->
                    <span (click)="download()">{{keyFile}}</span>
                  <!-- </mat-form-field> -->
                  </div>
                </div>
                <div class="btn-signup-grid">
                  <button mat-raised-button class="btn" routerLink="/baseapp/instances">Back</button>
                  <!-- <button mat-raised-button type="submit" class="btn btn-signup">Add</button> -->
                </div>
              </form>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- <mat-card class="margin-top-10">
          <mat-card-title class="mc-title">
            <h4 class="mat-title-header">Additional Information</h4>
          </mat-card-title>
          <mat-card-content class="mc-content">
            <div class="form-container">
              <div class="list-info">
                <span>Created By</span>
                <span>{{dbEnvObj?.created_by}}</span>
              </div>
              <div class="list-info">
                <span>Updated By</span>
                <span>{{dbEnvObj?.updated_by}}</span>
              </div>
              <div class="list-info">
                <span>Created Date</span>
                <span>{{dbEnvObj?.created_date | date: 'medium'}}</span>
              </div>
              <div class="list-info">
                <span>Updated Date</span>
                <span>{{dbEnvObj?.updated_date | date: 'medium'}}</span>
              </div>
              <div class="list-info">
                <span>Created IP Address</span>
                <span>{{dbEnvObj?.created_ip_address}}</span>
              </div>
              <div class="list-info">
                <span>Updated IP Address</span>
                <span>{{dbEnvObj?.updated_ip_address}}</span>
              </div>
              <div class="btn-signup-grid">
                <button mat-raised-button type="submit" routerLink="/baseapp/database-env" class="btn btn-signup">Go Back</button>
              </div>
            </div>
          </mat-card-content>
        </mat-card> -->
      </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>

